/* eslint-disable react/jsx-no-bind */
import React, { useState } from 'react';
import { contactsAPI } from '../../contactsAPI';
import { useStyles } from './ContactsDrawer.styles';
export function GroupsPanel({ groups, onRefresh }) {
    const { classes, cx } = useStyles();
    const [newGroupName, setNewGroupName] = useState('');
    const [creating, setCreating] = useState(false);
    const handleCreate = async () => {
        if (!newGroupName.trim())
            return;
        setCreating(true);
        try {
            await contactsAPI.createGroup({ name: newGroupName.trim() });
            setNewGroupName('');
            onRefresh();
        }
        catch (err) {
            alert(err instanceof Error ? err.message : 'Failed to create group');
        }
        finally {
            setCreating(false);
        }
    };
    const handleDelete = async (gid) => {
        if (!confirm('Delete this group?'))
            return;
        try {
            await contactsAPI.deleteGroup(gid);
            onRefresh();
        }
        catch {
            // Silently fail
        }
    };
    return (React.createElement("div", { style: { padding: '16px' } },
        React.createElement("div", { className: classes.detailSectionTitle }, "Your Groups"),
        groups.length === 0 && (React.createElement("div", { className: classes.emptyState }, "No groups yet.")),
        groups.map(g => (React.createElement("div", { className: classes.blockedRow, key: g.id, style: { padding: '10px 12px' } },
            React.createElement("div", null,
                React.createElement("div", { className: classes.blockedInfo },
                    g.color && (React.createElement("span", { style: {
                            display: 'inline-block',
                            width: '10px',
                            height: '10px',
                            borderRadius: '50%',
                            backgroundColor: g.color,
                            marginRight: '6px'
                        } })),
                    g.name),
                React.createElement("div", { className: classes.blockedReason },
                    g.member_count,
                    " member",
                    g.member_count !== 1 ? 's' : '')),
            React.createElement("button", { className: classes.unblockBtn, onClick: () => handleDelete(g.id), type: 'button' }, "Delete")))),
        React.createElement("div", { style: { marginTop: '16px', display: 'flex', gap: '8px' } },
            React.createElement("input", { className: classes.formInput, onChange: e => setNewGroupName(e.target.value), onKeyDown: e => e.key === 'Enter' && handleCreate(), placeholder: 'New group name...', style: { flex: 1 }, type: 'text', value: newGroupName }),
            React.createElement("button", { className: cx(classes.saveBtn, creating && 'disabled'), disabled: creating || !newGroupName.trim(), onClick: handleCreate, style: { padding: '8px 16px' }, type: 'button' }, creating ? '...' : 'Add'))));
}
export function DuplicateSetCard({ dup, onMerge }) {
    const { classes } = useStyles();
    const [primaryId, setPrimaryId] = useState(dup.contacts[0]?.id || '');
    const secondaryIds = dup.contacts.filter(c => c.id !== primaryId).map(c => c.id);
    return (React.createElement("div", { className: classes.dupSet },
        React.createElement("div", { className: classes.dupField },
            "Duplicate ",
            dup.field,
            ": ",
            dup.value),
        dup.contacts.map(c => (React.createElement("div", { className: classes.dupContactRow, key: c.id },
            React.createElement("input", { checked: primaryId === c.id, className: classes.dupRadio, name: `dup-${dup.value}`, onChange: () => setPrimaryId(c.id), type: 'radio' }),
            React.createElement("span", { style: { fontSize: '14px', color: 'var(--text-color, #fff)' } },
                c.name,
                " ",
                c.phone_number ? `(${c.phone_number})` : '',
                " ",
                c.email ? `<${c.email}>` : '')))),
        React.createElement("button", { className: classes.mergeBtn, onClick: () => onMerge(primaryId, secondaryIds), type: 'button' },
            "Merge ",
            secondaryIds.length,
            " into selected")));
}
